'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound() {
  return _react2.default.createElement(
    _caligramReact.Page,
    { title: 'Oups!' },
    _react2.default.createElement(
      'p',
      null,
      'Cette page n\u2019existe pas.'
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/NotFound.js
// module id = 1172
// module chunks = 0